import React from 'react'
import { get } from 'lodash'
import SentimentVeryDis
  from 'material-ui/svg-icons/social/sentiment-very-dissatisfied'
import { themeColors } from '../styles/theme'
import withTopBar from '../common/TopBar/withTopBar'

const styles = {
  icon: {
    width: 60,
    height: 'auto',
    color: themeColors.energized,
  },
  container: {
    textAlign: 'center',
    padding: 5,
  },
  text: {
    color: themeColors.energized,
    marginTop: 0,
    marginBottom: 0,
  },
}

const ErrorPage = ({ error }) => {
  const statusCode = get(error, 'response.statusCode')

  let title
  let description

  if (statusCode === 404) {
    title = 'Not found'
    description = 'Ops! Pagina non trovata'
  } else if (statusCode > 0) {
    title = 'Sorry, got some troubles'
    description = 'Please try again later'
  } else {
    // JS falsy for status means or no-connection or timeout or dropping bomb
    title = 'You are offline'
    description = 'No connection, please check your network'
  }

  return (
    <div className="padding" style={styles.container}>
      <SentimentVeryDis style={styles.icon} />
      <h3 style={styles.text}>{title}</h3>
      <p style={styles.text}>{description}</p>
    </div>
  )
}

export default withTopBar({
  expandable: false,
  toolbar: 'WorldsToolbar',
  inner: 1,
})(ErrorPage)



// WEBPACK FOOTER //
// ./src/common/ErrorPage.js